import { forEach } from 'lodash';
import {
  FETCH_CARS_FINISHED,
  SET_CAR_ACTIVE_FLAG_DONE,
  UPDATE_CAR_USER_PRIMARY_DONE,
  ADD_CAR_SUCCESSED
} from '../actions/constantsActions';

const carReducer = (state = {}, action) => {
  const { type, payload } = action;
  const newState = {};

  switch (type) {
    case FETCH_CARS_FINISHED:
      forEach(payload, (car) => {
        newState[car.carId] = car;
      });

      return {
        ...state,
        ...newState
      };
    case SET_CAR_ACTIVE_FLAG_DONE:
      newState[payload.carId] = {
        ...state[payload.carId],
        ...{
          active: payload.active
        }
      };
      
      return {
        ...state,
        ...newState
      };
    case UPDATE_CAR_USER_PRIMARY_DONE:
      forEach(state, (car) => {
        newState[car.carId] = car
        newState[car.carId].primary = (car.carId === payload)
      })

      return {
        ...state,
        ...newState
      }
    case ADD_CAR_SUCCESSED:
      newState[payload.carId] = payload
      return {
        ...state,
        ...newState
      }
    default:
      return state;
  }
};

export default carReducer;
